import React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
import isAppleMobile from "./utils/isAppleMobile";
import { BrowserRouter } from "react-router-dom";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <App isIOS={isAppleMobile()} />
  </BrowserRouter>,
);
